import { Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";
import { LoginForm } from "../sections/auth/login";

const StyledRoot = styled("div")(({ theme }) => ({
	[theme.breakpoints.up("md")]: {
		display: "flex",
	},
}));

const StyledContent = styled("div")(({ theme }) => ({
	maxWidth: 480,
	margin: "auto",
	minHeight: "100vh",
	display: "flex",
	justifyContent: "center",
	flexDirection: "column",
	padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
	return (
		<>
			<Helmet>
				<title> Login | PLN Admin </title>
			</Helmet>

			<StyledRoot>
				<Container maxWidth="sm">
					<StyledContent>
						<LoginForm />
					</StyledContent>
				</Container>
			</StyledRoot>
		</>
	);
}
